<template>
	<v-form
		ref="form"
		v-if="selectedEntity && defaultGridView && loaded"
		class="grid-flex-container"
	>
		<div
			class="d-sm-block flex-column flex-wrap flex-grow-1"
			:class="getOverflowYClass"
		>
			<div
				class="px-4 py-2"
				:class="getGVFClass"
				v-for="(field, index) in visibleFields"
				:key="index"
			>
				<GridField
					:tabIndex="getTabIndex(field)"
					:gridViewField="field"
					:defaultGridView="defaultGridView"
				/>
			</div>
		</div>
		<v-container fluid class="align-end">
			<v-row no-gutters>
				<v-spacer />
				<v-btn text class="mr-2" outlined @click="closeEdit()"
					>Cancel</v-btn
				>
				<v-btn color="primary" @click="saveItem()">Save</v-btn>
			</v-row>
		</v-container>
	</v-form>
</template>
<script>
import GridField from './GridField.vue';
import { GridsPageEditActions, GridsPageActions } from '../../../store/actions';
import { GridsGetters } from '../../../store/getters';
import { mapGetters } from 'vuex';
import { gridViewTypes } from '../../../enums/gridViewTypes';
import projectSettingsMixin from '../../../mixins/projectSettingsMixin';
export default {
	name: 'ManageGridView',
	mixins: [projectSettingsMixin],
	data() {
		return {
			loaded: false,
		};
	},
	components: { GridField },
	computed: {
		getOverflowYClass() {
			let width = this.getGridsColumnWidth(this.entityType);
			if (width === '1') return 'overflow-y-auto';
			if (width === '2') {
				if (!this.$vuetify.breakpoint.mdAndUp) return 'overflow-y-auto';
				return 'd-md-flex overflow-y-hidden';
			}
			return 'overflow-y-auto';
		},

		getGVFClass() {
			if (!this.$vuetify.breakpoint.mdAndUp) return 'gvf-sm';
			let width = this.getGridsColumnWidth(this.entityType);
			if (width === '1') return 'gvf-sm';
			if (width === '2') return 'gvf-md';
			return 'gvf-sm';
		},

		...mapGetters({
			entities: [GridsGetters.GET_ENTITIES],
			gridViews: [GridsGetters.GET_GRID_VIEWS],
		}),
		selectedEntity() {
			if (!this.entityType) return null;
			if (!this.entities) return null;
			return this.entities.find((x) => x.Name === this.entityType);
		},
		defaultGridView() {
			if (!this.selectedEntity) return null;
			if (!this.gridViews) return null;
			return this.gridViews.find(
				(x) =>
					x.EntityId === this.selectedEntity.Id &&
					x.UserId === null &&
					x.Type === gridViewTypes.Grids
			);
		},
		visibleFields() {
			if (!this.defaultGridView) return [];
			return this.defaultGridView.Columns.filter(
				(x) => x.IsVisibleEditForm === true
			).sort((a, b) => a.Order - b.Order);
		},
		recordId() {
			return this.$route.params.recordId;
		},
		entityType() {
			return this.$route.params.pageName;
		},
	},
	mounted() {
		if (this.recordId) {
			this.$store
				.dispatch(GridsPageEditActions.LOAD, {
					recordId: this.recordId,
					selectedEntity: this.selectedEntity,
					gridViewId: this.defaultGridView.Id,
				})
				.then(() => {
					this.loaded = true;
				});
		} else {
			this.loaded = true;
		}
	},
	methods: {
		saveItem() {
			if (this.$refs.form.validate()) {
				this.$store
					.dispatch(GridsPageEditActions.UPDATE, this.selectedEntity)
					.then(() => {
						this.closeEdit();
					})
					.catch(() => {
						alert('Please fill in at least one field');
					});
			}
		},
		closeEdit() {
			this.$router.push(
				this.$route.path.split(`/${this.entityType}`)[0] +
					`/${this.entityType}`
			);
			this.$store.dispatch(GridsPageActions.LOAD_GRID_DATA);
		},

		getTabIndex(gvf) {
			let offset = 1;
			if (this.visibleFields && this.visibleFields.length > 0) {
				let index = this.visibleFields.indexOf(gvf);
				if (index > 0) offset = offset + index;
			}
			return 100 + offset;
		},
	},
};
</script>

<style lang="scss">
.gvf-sm {
	width: 100%;
}

.gvf-md {
	width: 50%;
}
</style>
